export default Object.freeze({
  FORBIDDEN: 1,
  ALLOW: 2,
  MANAGE: 3,
});
